import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { ModuleModel } from 'app/audit/models/module.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { AuditTemplateDetailsModel } from '../../../audit-template/models/audit-template-details.model';
import { CompanyService } from '../../services/company.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-company-audit-template-add',
  templateUrl: './company-audit-template-add.component.html',
  styleUrls: ['./company-audit-template-add.component.css']
})
export class CompanyAuditTemplateAddComponent implements OnInit {
    errors: string[];
    @Input() companyId: string;
    @Output() auditTemplateAdded: EventEmitter<string> = new EventEmitter<string>();
    auditTemplates: AuditTemplateDetailsModel[];
    addAuditTemplateForm: FormGroup;
    submitAttempt: boolean = false;
    showForm: boolean = false;

    constructor(
        private router: Router,
        private companyService: CompanyService,
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTemplates();
    }

    initializeForm(): void {
        this.addAuditTemplateForm = this.fb.group({
            auditTemplateId: ['', Validators.required],
            companyId: [this.companyId]
        });
    }

    getAuditTemplates(): void {
        this.auditTemplateService.getAll().subscribe(result => {
            this.auditTemplates = result;
        });
    }

    openAddTemplate(content) {
        this.modalService.open(content);
        this.initializeForm();
    }

    addAuditTemplateToCompany(): void {
        this.submitAttempt = true;
        if (this.addAuditTemplateForm.valid) {
            const formValue = this.addAuditTemplateForm.value;
            formValue.auditTemplateDescription = this.auditTemplates.find(template => template.id === formValue.auditTemplateId).description;
            this.companyService.addAuditTemplateToCompany(formValue).subscribe(
                result => {
                    this.auditTemplateAdded.emit(result);
                    this.addAuditTemplateForm.reset();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

}
